import React from 'react';
import { BrowserRouter, Route, Routes, Link, Navigate } from 'react-router-dom';
import Sidebar from './components/sidebar/Sidebar';
import Home from './components/Home'
import About from './components/About';
import './custom.css';
import News from './components/News';
import Login from './components/Auth/Login';
import Logout from './components/Auth/Logout';
import LandingPage from './components/Landing';
import ComingSoon from './components/ComingSoon/ComingSoon';

function AuthenticatedApp() {
  return (
    <div className='Main'>
      <BrowserRouter>
        <div className='Sidebar'>
          <Sidebar/>
        </div>
        <div className='Content'>
          <Routes>
            <Route path="/landing" element={<LandingPage />} />
            <Route exact path="/" element={<Home />}/>
            <Route path="/notes" element={<ComingSoon />}/>
            <Route path="/tags" element={<ComingSoon />}/>
            <Route path="/about" element={<About />} />
            <Route path="/form" element={<ComingSoon />} />
            <Route path="/user" element={<ComingSoon />} />
            <Route path="/drive" element={<ComingSoon />} />
            <Route path="/settings" element={<ComingSoon />} />
            <Route path="/contact" element={<ComingSoon />} />
            <Route path="/news" element={<News />} />
            <Route path="/logout" element={<Logout />} />
            <Route exact path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <div className='footer'>
            <p>&copy; {new Date().getFullYear()} <Link className='url' to='https://enally.in'>Enally.in</Link>. All rights reserved. Developed by <Link className='url' to='https://www.linkedin.com/in/03prashantpk/'>Prashant Kumar</Link></p>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

function App() {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  return isLoggedIn ? <AuthenticatedApp /> :  <Login/>;
}

export default App;
